import { css } from '@emotion/react'
import styled from '@emotion/styled'
import StarRoundedIcon from '@mui/icons-material/StarRounded'
import { theme } from 'styles/theme/hav-theme'

type DataWrapProps = {
  achieved?: boolean
}
export const DataWrap = styled.div<DataWrapProps>`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};

  ${({ achieved }) =>
    achieved &&
    css`
      svg {
        path {
          fill: ${theme.colors.alert.success.dark};
        }
      }

      span {
        color: ${theme.colors.alert.success.dark};
        font-family: ${theme.typography.family.bold};
      }
    `}
`

export const EmptyIcon = styled.div`
  width: 16px;
  height: 16px;
`

export const StarIcon = styled(StarRoundedIcon)`
  font-size: 16px;
`
